/* eslint-disable import/prefer-default-export */
import { preferencesListeners as libraryListeners } from '@socialive/preferences';
import * as listeners from './listeners';

export const preferencesListeners = [].concat(...Object.values(libraryListeners), ...Object.values(listeners));
